// NOTE - This button is intended for use within a link row so that the whole row is clicked not the button
import { ui } from "@patient-watch/ui";
import { ChevronRight } from "lucide-react";

const ChevronButton = () => {
    return (
        <ui.Button asChild size="icon" variant="outline" className="p-0 pl-[2px] rounded-full w-10 h-10" tabIndex={-1}>
            <ChevronRight size={24} />
        </ui.Button>
    );
};

export default ChevronButton;
